import animation from './assets/loader.json';
import lottie from 'lottie-web';
import './spinner.scss';

lottie.loadAnimation({
    container: document.querySelector('#spinner-animation'),
    animationData: animation,
});
